module.exports = __webpack_public_path__ + "img/t1.3fcf63fc.jpeg";